module.exports = __webpack_public_path__ + "static/media/graph.915f4aec.svg";